module.exports = __webpack_public_path__ + "img/selected4-min.7456a8b8.png";